/* eslint-disable react/prop-types */
import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Table, Select, notification, Popconfirm, Checkbox,
} from 'antd';
import Joi from 'joi';
import H3Text from '@Uilib/h3Text';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import BusyIntegrationActions from '../../../../../../../actions/integrations/busyIntegrationAction';
import BusyTabLoading from '../../BusyTabLoading';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const BusyConfig = ({
  user, connectToBusyLocationLoading, setStep,
  getBusyConnections, connectToBusyLocation, getBusyConnectionsLoading,
  busyConnection, stepNumber,
}) => {
  const defaultState = Joi.object({
    integration_busy_id: Joi.number(),
    is_demo_account: Joi.boolean().default(false).allow(null),
    sales_voucher_integration: Joi.boolean().default(false),
    purchase_voucher_integration: Joi.boolean().default(false),
    credit_note_voucher_integration: Joi.boolean().default(false),
    debit_note_voucher_integration: Joi.boolean().default(false),
    shipping_charge_account: Joi.string().default('').allow('', null).default(''),
    purchase_shipping_charge_account: Joi.custom(global.joi_string),
    create_shipping_charge_as_expense: Joi.custom(global.joi_default_false),
  });
  const [selectedBusyConnection, setSelectedBusyConnection] = useState(null);

  useEffect(() => {
    const _tmp = global.joiValidate(defaultState, busyConnection);
    setSelectedBusyConnection(_tmp);
  }, [busyConnection]);

  const handleSubmit = () => {
    connectToBusyLocation(selectedBusyConnection, () => {
      getBusyConnections(user?.tenant_info?.org_id, () => setStep(Number(stepNumber) + 1));
    });
  };

  if (getBusyConnectionsLoading || !selectedBusyConnection) return <BusyTabLoading />;
  return (
    <div className="busy__config-wrapper">
      <div className="ant-col-md-18">

        <div className="demo__checkbox-wrapper">
          <Checkbox
            checked={selectedBusyConnection.is_demo_account}
            onChange={(e) => global.setStateJSON(setSelectedBusyConnection, 'is_demo_account', e.target.checked)}
          />
                    &nbsp;&nbsp;
          <H3Text
            text="Busy Running on Demo"
            className="demo__checkbox-label"
          />
        </div>
        <div className="demo__checkbox-wrapper">
          <Checkbox
            checked={selectedBusyConnection.sales_voucher_integration}
            onChange={(e) => global.setStateJSON(setSelectedBusyConnection, 'sales_voucher_integration', e.target.checked)}
          />
                    &nbsp;&nbsp;
          <H3Text
            text="Sales Voucher Integration"
            className="demo__checkbox-label"
          />
        </div>
        {((key) => (
          <div
            className="busy__shipping-charges-wrapper"
          >
            <div
              className="busy__shipping-charges-heading"
            >
              Sales Shipping Charges Account

            </div>
            <PRZSelect
              value={selectedBusyConnection[key]}
              onChange={(value) => global.setStateJSON(setSelectedBusyConnection, key, value)}
              disabled={connectToBusyLocationLoading || getBusyConnectionsLoading || !selectedBusyConnection?.sales_voucher_integration}
              placeholder=""
            >
              {(busyConnection?.bill_sundry_master_list || [])?.map((item) => (
                <Option key={item.name} value={item.name}>
                  {item?.name}
                </Option>
              ))}
            </PRZSelect>
            <Checkbox
              style={{
                marginTop: '10px',
              }}
              checked={selectedBusyConnection.create_shipping_charge_as_expense}
              onChange={(e) => global.setStateJSON(setSelectedBusyConnection, 'create_shipping_charge_as_expense', e.target.checked)}
            >
              Create Shipping Charge As Expense

            </Checkbox>
          </div>
        ))('shipping_charge_account')}
        <div className="demo__checkbox-wrapper">
          <Checkbox
            checked={selectedBusyConnection.purchase_voucher_integration}
            onChange={(e) => global.setStateJSON(setSelectedBusyConnection, 'purchase_voucher_integration', e.target.checked)}
          />
                    &nbsp;&nbsp;
          <H3Text
            text="Purchase Voucher Integration"
            className="demo__checkbox-label"
          />
        </div>
        {((key) => (
          <div
            className="busy__shipping-charges-wrapper"
          >
            <div
              className="busy__shipping-charges-heading"
            >
              Purchase Shipping Charges Account

            </div>
            <PRZSelect
              value={selectedBusyConnection[key]}
              onChange={(value) => global.setStateJSON(setSelectedBusyConnection, key, value)}
              disabled={connectToBusyLocationLoading || getBusyConnectionsLoading || !selectedBusyConnection.purchase_voucher_integration}
            >
              {(busyConnection?.bill_sundry_master_list || [])?.map((item) => (
                <Option key={item.name} value={item.name}>
                  {item?.name}
                </Option>
              ))}
            </PRZSelect>
          </div>
        ))('purchase_shipping_charge_account')}
        <div className="demo__checkbox-wrapper">
          <Checkbox
            checked={selectedBusyConnection.credit_note_voucher_integration}
            onChange={(e) => global.setStateJSON(setSelectedBusyConnection, 'credit_note_voucher_integration', e.target.checked)}
          />
                    &nbsp;&nbsp;
          <H3Text
            text="Credit Note Voucher Integration"
            className="demo__checkbox-label"
          />
        </div>
        <div className="demo__checkbox-wrapper">
          <Checkbox
            checked={selectedBusyConnection.debit_note_voucher_integration}
            onChange={(e) => global.setStateJSON(setSelectedBusyConnection, 'debit_note_voucher_integration', e.target.checked)}
          />
                    &nbsp;&nbsp;
          <H3Text
            text="Debit Note Voucher Integration"
            className="demo__checkbox-label"
          />
        </div>
      </div>
      <div className="ant-row" style={{ display: 'flex', marginTop: '7px 0px 50px 0px' }}>
        <H3Button
          text="Back"
          buttonType={defaultButtonTypes.BLUE_BORDERED}
          onClick={() => setStep(4)}
          customClass="busy__action-button"
          disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
        />
                &nbsp;&nbsp;
                &nbsp;&nbsp;
        <div>
          <H3Button
            text="Save and Continue"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => handleSubmit()}
            customClass="busy__location-submit"
            isLoading={connectToBusyLocationLoading || getBusyConnectionsLoading}
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  connectToBusyLocationLoading: BusyIntegrationReducers.connectToBusyLocationLoading,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getBusyConnections: (orgId, callback) => dispatch(BusyIntegrationActions.getBusyConnections(orgId, callback)),
  connectToBusyLocation: (payload, callback) => dispatch(BusyIntegrationActions.connectToBusyLocation(payload, callback)),
});

BusyConfig.propTypes = {
  user: PropTypes.any,
  connectToBusyLocationLoading: PropTypes.bool,
  getBusyConnectionsLoading: PropTypes.bool,
  setStep: PropTypes.func,
  getBusyConnections: PropTypes.func,
  connectToBusyLocation: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusyConfig));
